const Footer = () => {
    return (
        <footer className="footer">
            <p><small>Utkarsh Hadgekar &copy; 2023</small></p>
        </footer>
    );
}

export default Footer;